<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-search"></i>
          {{
            $t("public.views.Pages.Professional.Admin.Invoices.search.title")
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="mr-2" style="right" variant="primary" @click="goToInvoiceOlds">Antiguas
        </b-button>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtStart">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.dateAtStart"
                )
              }}:
              </template>
              <date-picker v-model="filter.startTo" :format="myFormat" :formatter="momentFormat" class="w-100" type="date"
                @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="dateAtEnd">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.dateAtEnd"
                )
              }}:
              </template>
              <date-picker v-model="filter.startFrom" :format="myFormat" :formatter="momentFormat" class="w-100"
                type="date" @input="changeFilter"></date-picker>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="professionals">
              <template slot="label">{{
                $t(
                  "public.views.Pages.Professional.Admin.Invoices.professional"
                )
              }}:
              </template>

              <multiselect v-model="filter.professionals" :clear-on-select="false" :close-on-select="false"
                :multiple="true" :options="professionalsFilterSelect" :preselect-first="true" :preserve-search="true"
                label="text" track-by="value" v-bind:deselectGroupLabel="
                  $t(
                    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectGroupLabel'
                  )
                " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.placeholder2'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectedLabel'
  )
" @input="changeFilter">
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Invoices.selectedProfessionals"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="patients">
              <template slot="label">{{
                $t("public.views.Pages.Professional.Admin.Invoices.patient")
              }}:
              </template>
              <multiselect v-model="filter.patients" :clear-on-select="false" :close-on-select="false"
                :loading="isLoadingPatients" :multiple="true" :options="patientsFilterSelect" :preselect-first="true"
                :preserve-search="true" label="text" track-by="value" v-bind:deselectGroupLabel="
                  $t(
                    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectGroupLabel'
                  )
                " v-bind:deselectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.deselectLabel'
  )
" v-bind:placeholder="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.placeholder'
  )
" v-bind:selectGroupLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectGroupLabel'
  )
" v-bind:selectLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectLabel'
  )
" v-bind:selectedLabel="
  $t(
    'public.views.Pages.Professional.Admin.Invoices.multiselect.selectedLabel'
  )
" @input="changeFilter" @search-change="getAllPatients">
                <template slot="noResult">
                  {{ $t("generic.noResults") }}
                </template>
                <template slot="noOptions">
                  {{ $t("generic.min3") }}
                </template>
                <template slot="option" slot-scope="props">
                  <b-list-group-item class="d-flex align-items-center">
                    <b-avatar class="mr-3" v-bind:src="props.option.avatar"></b-avatar>
                    <span class="mr-auto title-typography-color">{{
                      props.option.text
                    }}</span>
                  </b-list-group-item>
                </template>
                <template slot="selection" slot-scope="{ values, isOpen }"><span v-if="values.length && !isOpen"
                    class="multiselect__single">{{ values.length }}
                    {{
                      $t(
                        "public.views.Pages.Professional.Admin.Invoices.selectedContacts"
                      )
                    }}</span></template>
              </multiselect>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="event">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.filters.event"
                  )
                }}:
              </template>
              <b-input v-model="filter.event" type="number" @input="changeFilter"></b-input>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="price">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.filters.price"
                  )
                }}:
              </template>
              <b-input v-model="filter.price" type="number" @input="changeFilter"></b-input>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="paid">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.filters.status"
                  )
                }}:
              </template>
              <b-form-select v-model="filter.paid" :options="statusSelect" @input="changeFilter">
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col lg="3" md="3" sm="6" xl="3">
            <b-form-group label-for="type">
              <template slot="label">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.filters.type"
                  )
                }}:
              </template>
              <b-form-select v-model="filter.type" :options="typeSelect" @input="changeFilter">
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file-invoice-dollar"></i>
          {{ $t("public.views.Pages.Professional.Admin.Invoices.title") }}
        </h4>
      </template>
      <template v-slot:body>
        <div class="text-right">
          <b-button class="mb-3 mr-1" variant="secondary" @click="getInvoicesExcel">
            Excel
          </b-button>
        </div>
        <div>
          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="invoices" :options.sync="pagination" :search="search"
            :server-items-length="total" item-key="id">
            <template v-slot:item.invoiceNumber="{ item }">
              <div v-if="item.invoiceNumber && (item.type === 'NORMAL' || item.type === 'CANCELED')">
                {{ item.invoiceNumber }}
              </div>
              <div v-if="item.rectifyNumber && item.type === 'RECTIFY'">
                <i :id="'exclamation' + item.rectifyNumber" class="
                          fas
                          fa-exclamation-triangle fa-cols-xs
                          text-primary
                          fa-fw
                          cursor-point
                        "></i>
                <b-popover :target="'exclamation' + item.rectifyNumber" placement="botton" triggers="hover focus">
                  <template #title>Hace referencia a la factura:
                    {{ item.invoiceNumberRectify }}
                  </template>
                </b-popover>
                R{{ item.rectifyNumber }}
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <div v-if="item.type === 'NORMAL'">Vigente</div>
              <div v-if="item.type === 'RECTIFY'">Rectificativa</div>
              <div v-if="item.type === 'CANCELED'">Cancelada</div>
            </template>
            <template v-slot:item.event="{ item }">
              <div v-if="
                item.billing && item.billing.room && item.billing.room.event
              ">
                {{ item.billing.room.event.id }}
              </div>
            </template>
            <template v-slot:item.patient="{ item }">
              <div v-if="item.buyer">
                {{ item.buyer.name }} {{ item.buyer.lastname }}
              </div>
            </template>
            <template v-slot:item.professional="{ item }">
              <div v-if="item.seller">
                {{ item.seller.name }} {{ item.seller.lastname }}
              </div>
            </template>
            <template v-slot:item.date="{ item }">
              <div v-if="item.date">
                {{ item.date | adjustToTimezone("DD/MM/YYYY") }}
              </div>
            </template>
            <template v-slot:item.price="{ item }">
              <b-badge v-if="item.total > 0" variant="success">
                {{ item.total.toFixed(2) }} €
              </b-badge>
              <b-badge v-if="item.total <= 0" variant="danger">
                {{ item.total.toFixed(2) }} €
              </b-badge>
            </template>
            <template v-slot:item.status="{ item }">
              <span v-if="
                item.billing &&
                item.billing.payment &&
                item.billing.payment.paymentStatus === 'SUCCESS'
              " class="badge badge-success">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.status.paid"
                  )
                }}
              </span>
              <span v-else class="badge badge-danger">
                {{
                  $t(
                    "public.views.Pages.Professional.Admin.Invoices.status.pending"
                  )
                }}
              </span>
            </template>

            <template v-slot:item.actions="{ item }">
              <div class="div-table-data">
                <button v-if="item.type === 'NORMAL'" :id="'btnDownload' + item.id" class="item"
                  v-on:click="download(item.id)">
                  <i class="ri-file-download-line"></i>
                </button>
                <b-popover v-if="item.type === 'NORMAL'" :target="'btnDownload' + item.id" placement="botton"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnDownload"
                    )
                  }}
                  </template>
                </b-popover>

                <button v-if="item.type === 'NORMAL'" :id="'btnSend' + item.id" class="item" v-on:click="send(item.id)">
                  <i class="ri-mail-send-line"></i>
                </button>
                <b-popover v-if="item.type === 'NORMAL'" :target="'btnSend' + item.id" placement="botton"
                  triggers="hover focus">
                  <template #title>{{
                    $t("public.views.Pages.Professional.Admin.Invoices.btnSend")
                  }}
                  </template>
                </b-popover>

                <button v-if="item.type === 'NORMAL' && item.billing.room.event.last" :id="'btnUpdate' + item.id"
                  class="item" v-on:click="update(item.id)">
                  <i class="ri-refresh-line"></i>
                </button>
                <b-popover v-if="item.type === 'NORMAL' && item.billing.room.event.last" :target="'btnUpdate' + item.id"
                  placement="botton" triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnUpdate"
                    )
                  }}
                  </template>
                </b-popover>

                <button v-if="item.type === 'NORMAL' && item.billing.room.event.last" :id="'btnGenerateRectify' + item.id"
                  class="item" v-on:click="cancel(item.id)">
                  <i class="ri-close-circle-line"></i>
                </button>
                <b-popover v-if="item.type === 'NORMAL' && item.billing.room.event.last"
                  :target="'btnGenerateRectify' + item.id" placement="botton" triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnGenerateRectify"
                    )
                  }}
                  </template>
                </b-popover>

                <button v-if="item.type === 'RECTIFY' && item.billing.room.event.last" :id="'btnUpdateRectify' + item.id"
                  class="item" v-on:click="updateRectify(item.id)">
                  <i class="ri-refresh-line"></i>
                </button>
                <b-popover v-if="item.type === 'RECTIFY' && item.billing.room.event.last"
                  :target="'btnUpdateRectify' + item.id" placement="botton" triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnUpdateRectify"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="item.type === 'RECTIFY'" :id="'btnDownloadRectify' + item.id" class="item"
                  v-on:click="downloadAbono(item.id)">
                  <i class="ri-file-download-line"></i>
                </button>
                <b-popover v-if="item.type === 'RECTIFY'" :target="'btnDownloadRectify' + item.id" placement="botton"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnDownloadRectify"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="item.type === 'RECTIFY'" :id="'btnSendRectify' + item.id" class="item"
                  v-on:click="send(item.id)">
                  <i class="ri-mail-send-line"></i>
                </button>
                <b-popover v-if="item.type === 'RECTIFY'" :target="'btnSendRectify' + item.id" placement="botton"
                  triggers="hover focus">
                  <template #title>{{
                    $t(
                      "public.views.Pages.Professional.Admin.Invoices.btnSendRectify"
                    )
                  }}
                  </template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
      </template>
    </iq-card>
    <b-modal id="modal-update" centered size="lg" @ok="updateInvoice">
      <template #modal-cancel>{{
        $t("public.views.Pages.Professional.Admin.Invoices.modal.btnCancel")
      }}
      </template>
      <template #modal-ok>{{
        $t("public.views.Pages.Professional.Admin.Invoices.modal.btnAdd")
      }}
      </template>
      <template #modal-title>
        {{ $t("public.views.Pages.Professional.Admin.Invoices.modal.title") }}
      </template>

      <b-row>
        <b-col cols="12">
          <h4>
            {{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.buyer.title"
              )
            }}
          </h4>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="buyer.name">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.buyer.name"
              )
            }}:
            </template>
            <b-form-input v-model="buyer.name" type="text" v-bind:class="{
              'text-danger': isFormBuyerNameErrors,
              'is-invalid': isFormBuyerNameErrors,
            }" @blur="checkBuyerName(buyer.name)"></b-form-input>
            <ul v-if="isFormBuyerNameErrors">
              <li v-for="(error, index) in validator.getErrors('buyer.name')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="buyer.lastname">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.buyer.lastname"
              )
            }}:
            </template>
            <b-form-input v-model="buyer.lastname" type="text" v-bind:class="{
              'text-danger': isFormBuyerLastnameErrors,
              'is-invalid': isFormBuyerLastnameErrors,
            }" @blur="checkBuyerLastname(buyer.lastname)"></b-form-input>
            <ul v-if="isFormBuyerLastnameErrors">
              <li v-for="(error, index) in validator.getErrors('buyer.lastname')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="buyer.address">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.buyer.address"
              )
            }}:
            </template>
            <b-form-input v-model="buyer.address" type="text" v-bind:class="{
              'text-danger': isFormBuyerAddressErrors,
              'is-invalid': isFormBuyerAddressErrors,
            }" @blur="checkBuyerAddress(buyer.name)"></b-form-input>
            <ul v-if="isFormBuyerAddressErrors">
              <li v-for="(error, index) in validator.getErrors('buyer.address')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="buyer.document">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.buyer.document"
              )
            }}:
            </template>
            <b-form-input v-model="buyer.document" type="text" v-bind:class="{
              'text-danger': isFormBuyerDocumentErrors,
              'is-invalid': isFormBuyerDocumentErrors,
            }" @blur="checkBuyerDocument(buyer.name)"></b-form-input>
            <ul v-if="isFormBuyerDocumentErrors">
              <li v-for="(error, index) in validator.getErrors('buyer.document')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h4>
            {{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.seller.title"
              )
            }}
          </h4>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="seller.name">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.seller.name"
              )
            }}:
            </template>
            <b-form-input v-model="seller.name" type="text" v-bind:class="{
              'text-danger': isFormSellerNameErrors,
              'is-invalid': isFormSellerNameErrors,
            }" @blur="checkSellerName(seller.name)"></b-form-input>
            <ul v-if="isFormSellerNameErrors">
              <li v-for="(error, index) in validator.getErrors('seller.name')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="seller.name">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.seller.lastname"
              )
            }}:
            </template>
            <b-form-input v-model="seller.lastname" type="text" v-bind:class="{
              'text-danger': isFormSellerLastnameErrors,
              'is-invalid': isFormSellerLastnameErrors,
            }" @blur="checkSellerLastname(seller.lastname)"></b-form-input>
            <ul v-if="isFormSellerLastnameErrors">
              <li v-for="(error, index) in validator.getErrors('seller.lastname')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="seller.address">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.seller.address"
              )
            }}:
            </template>
            <b-form-input v-model="seller.address" type="text" v-bind:class="{
              'text-danger': isFormSellerAddressErrors,
              'is-invalid': isFormSellerAddressErrors,
            }" @blur="checkSellerAddress(seller.name)"></b-form-input>
            <ul v-if="isFormSellerAddressErrors">
              <li v-for="(error, index) in validator.getErrors('seller.address')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label-for="seller.document">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.seller.document"
              )
            }}:
            </template>
            <b-form-input v-model="seller.document" type="text" v-bind:class="{
              'text-danger': isFormSellerDocumentErrors,
              'is-invalid': isFormSellerDocumentErrors,
            }" @blur="checkSellerDocument(seller.document)"></b-form-input>
            <ul v-if="isFormSellerDocumentErrors">
              <li v-for="(error, index) in validator.getErrors('seller.document')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <h4>
            {{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.item.title"
              )
            }}
          </h4>
        </b-col>
        <b-col v-for="(item, index) in items" v-bind:key="index" cols="12">
          <b-form-group label-for="item.name">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.item.name"
              )
            }}:
            </template>
            <b-form-input v-model="item.description" type="text" v-bind:class="{
              'text-danger': isFormItemDescriptionErrors,
              'is-invalid': isFormItemDescriptionErrors,
            }" @blur="checkItemDescription(item.description)"></b-form-input>
            <ul v-if="isFormItemDescriptionErrors">
              <li v-for="(error, index) in validator.getErrors('item.name')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
          <b-form-group label-for="item.total">
            <template slot="label">{{
              $t(
                "public.views.Pages.Professional.Admin.Invoices.modal.item.total"
              )
            }}:
            </template>
            <vue-numeric v-model="item.subtotal" :class="{
              'text-danger': isFormItemPriceErrors,
              'is-invalid': isFormItemPriceErrors,
            }" :max="1000" :min="1" :precision="2" currency="€" separator="."
              @blur="checkItemPrice(item.subtotal)"></vue-numeric>
            <ul v-if="isFormItemPriceErrors">
              <li v-for="(error, index) in validator.getErrors('item.total')" v-bind:key="index"
                class="form-text text-danger">
                &nbsp;{{ error }}
              </li>
            </ul>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>

<script>
import { xray } from "../../../../config/pluginInit";

import { saveAs } from "file-saver";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import InvoiceStatusSelect from "../../../../json/filter/InvoiceStatusSelect";
import validator from "vue-m-validator";
import InvoiceTypeSelect from "../../../../json/filter/InvoiceTypeSelect";

import professionalService from "../../../../services/professional";
import patientService from "../../../../services/patient";
import invoiceService from "../../../../services/invoice";
import scheduleService from "../../../../services/schedule";
import utilsService from "../../../../services/utils";

export default {
  name: "Invoice",
  mounted() {
    xray.index();
    this.getAll();
    this.getAllProfessionals();
    this.getAllVisitType();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_INVOICES", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAll();
        }
        this.start = true;
      },
    },
  },
  computed: {
    isFormBuyerNameErrors() {
      let errors = this.validator.getErrors("buyer.name");
      return errors && errors.length > 0;
    },
    isFormBuyerLastnameErrors() {
      let errors = this.validator.getErrors("buyer.lastname");
      return errors && errors.length > 0;
    },
    isFormBuyerAddressErrors() {
      let errors = this.validator.getErrors("buyer.address");
      return errors && errors.length > 0;
    },
    isFormBuyerDocumentErrors() {
      let errors = this.validator.getErrors("buyer.document");
      return errors && errors.length > 0;
    },
    isFormSellerNameErrors() {
      let errors = this.validator.getErrors("seller.name");
      return errors && errors.length > 0;
    },
    isFormSellerLastnameErrors() {
      let errors = this.validator.getErrors("seller.lastname");
      return errors && errors.length > 0;
    },
    isFormSellerAddressErrors() {
      let errors = this.validator.getErrors("seller.address");
      return errors && errors.length > 0;
    },
    isFormSellerDocumentErrors() {
      let errors = this.validator.getErrors("seller.document");
      return errors && errors.length > 0;
    },
    isFormItemDescriptionErrors() {
      let errors = this.validator.getErrors("item.name");
      return errors && errors.length > 0;
    },
    isFormItemPriceErrors() {
      let errors = this.validator.getErrors("item.total");
      return errors && errors.length > 0;
    },
  },
  methods: {
    goToInvoiceOlds() {
      this.$router.push({
        name: "auth.professional.admin.invoicesOld",
      });
    },
    send(invoiceId) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.sendPdfInvoiceEvent(invoiceId),
        (response) => {
          if (response) {
            self.$notify({
              group: "notificacions",
              title: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.title"
              ),
              text: self.$i18n.t(
                "public.views.Pages.Professional.Admin.Payments.notification.descSendInvoice"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.sendPdfInvoiceEvent",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              invoiceId: invoiceId
            })
          });
        },
        " "
      );
    },
    getInvoicesExcel() {
      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        invoiceService.getAllExcel(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_INVOICES_EXCEL", info: "" });
            saveAs(response.data, "invoices.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.getAllExcel",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    changeFilter() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getAll();
    },
    saveFormStep1(evt) {
      evt.preventDefault();

      this.checkFormStep1();
      if (this.validator.errors.length === 0) {
        //Call service to store data
        this.updateInvoice();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.notification.descErrorInvoice"
          ),
          type: "error",
        });
      }
    },
    checkFormStep1() {
      this.checkBuyerName(this.buyer.name);
      this.checkBuyerLastname(this.buyer.lastname);
      this.checkBuyerAddress(this.buyer.address);
      this.checkBuyerDocument(this.buyer.document);
      this.checkSellerName(this.seller.name);
      this.checkSellerLastname(this.seller.lastname);
      this.checkSellerDocument(this.seller.document);
      this.checkSellerAddress(this.seller.address);
      this.checkItemDescription(this.item.name);
      this.checkItemPrice(this.item.subtotal);
    },
    checkBuyerName(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "buyer.name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erBuyerName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBuyerLastname(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "buyer.lastname",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erBuyerLastName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBuyerAddress(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "buyer.address",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erBuyerAddress"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBuyerDocument(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "buyer.document",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erBuyerDocument"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkSellerName(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "seller.name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erSellerName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkSellerLastname(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "seller.lastname",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erSellerLastName"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkSellerAddress(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "seller.address",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erSellerAddress"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkSellerDocument(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "seller.document",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erSellerDocument"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkItemDescription(item) {
      const ITEM = item.trim();
      const RULE_1 = {
        expression: !ITEM || ITEM === "",
        name: "item.name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erConcept"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkItemPrice(item) {
      const ITEM = item;
      const RULE_1 = {
        expression: ITEM === "" || ITEM === null || ITEM === undefined,
        name: "item.total",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Admin.Invoices.errors.erConcept"
        ),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    cleanUpdateForm() {
      this.id = "";
      this.buyer = {
        name: "",
        address: "",
        document: "",
        lastname: "",
      };

      this.seller = {
        name: "",
        address: "",
        document: "",
        lastname: "",
      };
      this.items = [
        {
          description: "",
          subtotal: 0.0,
        },
      ];
    },
    //Validator methods
    notFirst() {
      this.isFirstRun = false;
    },
    //--
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                value: item.id,
                text: item.name,
              });
            });
            self.visitTypeSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllVisitTypeActive",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
    download(id) {
      this.downloadInvoice(id);
    },
    downloadAbono(id) {
      this.downloadInvoice(id);
    },
    update(id) {
      this.get(id);
    },
    updateRectify(id) {
      this.get(id);
    },
    cancel(id) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.cancel(id),
        (response) => {
          self.getAll();
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.descRectified"
            ),
            type: "success",
          });
        },
        (error) => {
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.error"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.descErrorRectified"
            ),
            type: "error",
          });
          utilsService.auditErrorFrontent({
            info: "invoiceService.rectify",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    updateInvoice() {
      let self = this;
      let invoice = {
        id: this.id,
        buyer: this.buyer,
        seller: this.seller,
        items: this.items,
      };

      this.$awn.asyncBlock(
        invoiceService.update(this.id, invoice),
        (response) => {
          self.getAll();
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.title"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.descSaveInvoice"
            ),
            type: "success",
          });
        },
        (error) => {
          self.$notify({
            group: "notificacions",
            title: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.error"
            ),
            text: this.$i18n.t(
              "public.views.Pages.Professional.Admin.Invoices.notification.descErrorSaveInvoice"
            ),
            type: "error",
          });
          utilsService.auditErrorFrontent({
            info: "invoiceService.update",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id, invoice: invoice
            })
          });
        },
        " "
      );
    },
    //Invoice
    downloadInvoice(invoiceId) {
      let self = this;

      this.$awn.asyncBlock(
        invoiceService.generatePdfInvoiceEvent(invoiceId),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "factura.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Admin.Invoices.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Admin.Invoices.notification.descGeneratedInvoice"
              ),
              type: "success",
            });
            this.$bvModal.hide("modal-cita");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.generatePdfInvoiceEvent",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              invoiceId: invoiceId
            })
          });
        },
        " "
      );
    },
    cloneFilterSend() {
      let clone = JSON.parse(JSON.stringify(this.filter));

      //Professionals

      if (clone.professionals) {
        let professionalREST = [];
        clone.professionals.forEach(function (professional) {
          professionalREST.push(professional.value);
        });
        clone.professionals = professionalREST;
      } else {
        clone.professionals = [];
      }

      //Patients

      if (clone.patients) {
        let patientsREST = [];
        clone.patients.forEach(function (patient) {
          patientsREST.push(patient.value);
        });
        clone.patients = patientsREST;
      } else {
        clone.patients = [];
      }

      // StartAt
      if (clone.startTo) {
        clone.startTo = moment(clone.startTo)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startTo = null;
      }

      if (clone.startFrom) {
        clone.startFrom = moment(clone.startFrom)
          .set("hour", 24)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startFrom = null;
      }

      //Price
      if (clone.price) {
        clone.price = clone.price;
      } else {
        clone.price = null;
      }

      //Paid

      if (clone.paid) {
        if (clone.paid === "ALL") {
          clone.paid = null;
        } else if (clone.paid === "PENDING") {
          clone.paid = false;
        } else if (clone.paid === "PAID") {
          clone.paid = true;
        } else {
          clone.paid = null;
        }
      } else {
        clone.paid = null;
      }
      //Type
      if (clone.type) {
        if (clone.type === "ALL") {
          clone.type = null;
        } else {
          clone.type = clone.type;
        }
      } else {
        clone.type = null;
      }

      //Event
      if (clone.event) {
        clone.event = clone.event;
      } else {
        clone.event = null;
      }

      return clone;
    },
    async getAll() {
      let self = this;

      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        invoiceService.getAll(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          if (response) {
            self.invoices = response.data.content;

            self.total = response.data.pageable.total;
            if (self.pagination.page >= response.data.pageable.totalPages) {
              self.pagination.page = response.data.pageable.totalPages;
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.getAll",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
    get(id) {
      let self = this;
      this.$awn.asyncBlock(
        invoiceService.get(id),
        (response) => {
          if (response) {
            self.$bvModal.show("modal-update");

            self.cleanUpdateForm();

            self.id = response.data.id;

            if (response.data.buyer) {
              self.buyer = response.data.buyer;
            }
            if (response.data.items && response.data.items.length !== 0) {
              self.items = response.data.items;
            }
            if (response.data.seller) {
              self.seller = response.data.seller;
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.get",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    async getAllPatients(query) {
      let self = this;

      if (query.length > 2) {
        this.isLoadingPatients = true;

        patientService
          .getAll(query)
          .then((response) => {
            let combo = [];
            response.data.forEach(function (item) {
              let data = {
                avatar: item.avatarUrl
                  ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                  : "",
                uuid: item.uuid,
                value: item.id,
                text:
                  item.name + " " + item.lastname + " (" + item.document + ") ",
              };
              combo.push(data);
            });
            self.patientsFilterSelect = combo;

            self.isLoadingPatients = false;
          })
          .catch((error) => {
            utilsService.auditErrorFrontent({
              info: "patientService.getAll",
              module: "view-pages-professional-admin-invoices",
              httpStatus: error.response ? error.response.status : null,
              endpoint: window.location.href,
              request: JSON.stringify({
                query: query
              })
            });
            self.isLoadingPatients = false;
          });
      }
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAll()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              uuid: item.uuid,
              value: item.id,
              text:
                item.name + " " + item.lastname + " (" + item.document + ") ",
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-professional-admin-invoices",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        });
    },
  },
  data() {
    return {
      isLoadingPatients: false,
      start: false,
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,

      search: "",

      //Search payment platform
      filter: {
        professionals: [],
        patients: [],
        startTo: null,
        startFrom: null,
        price: null,
        paid: null,
        type: null,
        event: null,
      },

      statusSelect: InvoiceStatusSelect,
      typeSelect: InvoiceTypeSelect,
      visitTypeSelect: [],

      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.invoiceNumber"
          ),
          align: "start",
          value: "invoiceNumber",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.event"
          ),
          value: "event",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.type"
          ),
          value: "type",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.date"
          ),
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.patient"
          ),
          value: "patient",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.professional"
          ),
          value: "professional",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Admin.Invoices.headers.price"
          ),
          value: "price",
        },
        {
          text: this.$i18n.t(
            "public.auth.professional.admin.invoices.headers.status"
          ),
          value: "status",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      invoices: [],
      professionalsFilterSelect: [],
      patientsFilterSelect: [],
      //visitType
      visitTypeMap: new Map(),
      //Form update
      id: "",
      buyer: {
        name: "",
        address: "",
        document: "",
        lastname: "",
      },
      seller: {
        name: "",
        address: "",
        document: "",
        lastname: "",
      },
      items: [
        {
          description: "",
          subtotal: 0.0,
        },
      ],

      //Validate
      validator: validator,
      //Data validate form
      isFirstRun: true,
      isValidate: false,
    };
  },

  components: {
    DatePicker,
    Multiselect,
  },
};
</script>
